import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';


@Component({
  selector: 'app-view-comments',
  standalone: false,
  templateUrl: './view-comments.component.html',
  styleUrl: './view-comments.component.css'
})
export class ViewCommentsComponent {
  @Input() ucmgData;
  constructor(
    public maintenanceService: MaintenanceService, 
    private toaster: ToastrService){
  }
  ngOnChanges(){
    this.ucmgData = JSON.parse(JSON.stringify(this.ucmgData));
  }
 
}
